module.exports = __webpack_public_path__ + "media/sub2-9-3.3a708526.mp4";